export enum CustomerActionType {
    Create = 1,
    Edit = 2
}